import Badge from "./Badge";

type BadgesProps = {
  badges: { icon: React.ReactNode, title: string }[];
}

const Badges = ({ badges }: BadgesProps) => {
  return (
    <div className="flex flex-col lg:flex-row gap-4 lg:gap-10 mt-4 lg:mt-10 flex-wrap justify-center">
      {badges.map((badge) => (
        <Badge key={badge.title} icon={badge.icon} title={badge.title} />
      ))}
    </div>
  )
}

export default Badges;